import type { NetworkPayload } from "../../../composites";

export const API = {
  checkInstantEligible: ({
    routing_number,
  }: API.InstantEligibilityRequest): NetworkPayload => {
    return {
      url: `transfers/instant/eligibility/${routing_number}/`,
      options: {
        method: "GET",
      },
    };
  },
  getInstantTransferFees: (): NetworkPayload => {
    return {
      url: "transfers/instant/fees/",
      options: {
        method: "GET",
      },
    };
  },
  getSameDayACHFees: (): NetworkPayload => {
    return {
      url: "transfers/same_day/fees/",
      options: {
        method: "GET",
      },
    };
  },
  submitTransferImmediate: ({
    idempotencyKey,
    payload,
  }: {
    idempotencyKey: UUID;
    payload: API.TransferImmediateRequest;
  }): NetworkPayload => {
    return {
      url: "transfers/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  submitTransferScheduled: ({
    idempotencyKey,
    payload,
  }: {
    idempotencyKey: UUID;
    payload: API.TransferScheduledRequest;
  }): NetworkPayload => {
    return {
      url: "transfers/scheduled/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },
  getFedNowPayment: ({
    paymentIdentification,
  }: API.FedNowPaymentRequest): NetworkPayload => {
    return {
      url: `transfers/instant/${paymentIdentification}/`,
      options: {
        method: "GET",
      },
    };
  },
};
